// extracted by mini-css-extract-plugin
module.exports = {"container":"_2J1vQus58lOqL576TzxV1q"};